export default __webpack_public_path__ + "c1def737a4137395a5a61fecc362fe15.png";